import { render, staticRenderFns } from "./ResourceContactInfo.vue?vue&type=template&id=32fddce4"
import script from "./ResourceContactInfo.vue?vue&type=script&lang=js"
export * from "./ResourceContactInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports